/* eslint-disable max-len */
/* eslint-disable react/jsx-indent */
/* eslint-disable indent */
import React, { useEffect, useState } from 'react'
import config from '../../../config'
import { currencySymbolMapping, timeDifference, timeZoneMap } from '../../../CommonComponent/staticValues';
import { dataService } from '../../../services/dataService';
import { AuctionDescription } from '../description';
import moment from "moment-timezone";

export default function AuctionOverView({ auctionData}) {
    const [domain, setDomain]= useState(' ');
    const [copied, setCopied] = useState(false);

    const featuredImage=Array.isArray(auctionData.auction_image) ? auctionData.auction_image.find((image) => image.featured).url : auctionData.auction_image;

    const viewDomain = async () => {
        const endpoint="?view=True";
        const body={}
        const response=await dataService.SubDomainSetup(endpoint,body);
        setDomain(response.data?.subdomain);
    }

    useEffect(()=> {
        viewDomain();
    },[])

    const shareURL = `https://${domain}.${config.Environment.domain}/auctions/${auctionData._id}`; 

    const convertTimestampToDayMonthYear = (timestamp, time_zone, time_zone_data) => {
        if (timestamp === '' || !timestamp) {
            return '-';
        }
        let resolvedTimeZone = timeZoneMap[time_zone] || 'Etc/GMT';

        if (!moment.tz.zone(resolvedTimeZone)) {
            resolvedTimeZone = 'Etc/GMT';
        }

        if(time_zone_data){
            const tz = moment.tz(timestamp, time_zone_data.timeZoneId);
            const formatted = tz.format("DD MMM YYYY / HH:mm");
            const abbr = tz.zoneAbbr();
            return `${formatted} ${abbr} (UTC${tz.format("Z")})`;
        }

        const formatted = moment.tz(timestamp, resolvedTimeZone).format("DD MMM YYYY / HH:mm");
        const label = time_zone === '' ? 'GMT' : time_zone.split(' - ')[0];
        const offset = timeDifference[time_zone === '' ? 'GMT - Greenwich Mean Time' : time_zone] || '';

        return `${formatted} ${label} ${offset}`;
    };


    const handleCopyLink = () => {
        // Copy the auction URL to the clipboard
        navigator.clipboard.writeText(shareURL)
            .then(() => {
                setCopied(true);
                setTimeout(() => {
                    setCopied(false)
                }, 800);
            })
            .catch((error) => {
                console.error('Failed to copy URL: ', error);
            });
    };

    return (
        <div
            className="pb-10 transition-opacity duration-150 ease-linear data-[te-tab-active]:block"
            id="tabs-home3"
            role="tabpanel"
                    
            aria-labelledby="tabs-home-tab3">
            {/* <!-- overview content --> */}
            <div className="mt-[25px]  rounded-[8px] border-[#DEDEDE] border">
                <p className="py-5 border-b border-[#CECECE] pl-[35px] px-4 text-[16px] font-medium 
                leading-normal text-[#343434]">Information</p>
                {/* <!-- information content --> */}
                <div className="flex flex-wrap mt-8 mb-[15px] w-full">
                    <div className=" xxs:w-[30%] w-full pl-[35px] mb-10">
                        <p className="text-[10px] font-medium leading-normal text-[#343434]">Thumbnail</p>
                        {auctionData.auction_image!==''?
                            <img 
                                src={`${config.Storage.CDN}${featuredImage} `} 
                                className="py-2 w-[80px]  h-[77px]" alt="img" />
                            :
                            <p className='text-[16px] font-medium leading-normal text-[#343434]'>-</p>
                        }
                    </div>
                    <div className="auction-description-overview xs:w-[70%] w-full md:pr-[54px] pr-5 xs:pl-0 pl-[35px]  mb-10">
                        <p className="text-[10px] font-medium leading-normal text-[#343434]">Description</p>
                        <AuctionDescription
                            description={auctionData.description}
                            className='text-[16px] font-medium leading-normal text-[#343434] break-words'
                            emptyDescriptionPlaceholder='-'
                        />
                    </div>
                    <div className="md:w-[30%] xs:w-[30%] w-full pl-[35px] mb-10">
                        <p className="text-[10px] font-medium leading-normal text-[#343434]">Currency</p>
                        <p className="text-[16px] font-medium break-words leading-normal text-[#343434]">{auctionData.currency}</p>
                    </div>
                    <div className="md:w-[33%] xs:w-[50%] w-full xs:pl-0 pl-[35px]  mb-10">
                        <p className="text-[10px] font-medium leading-normal text-[#343434]">Start Date / Time</p>
                        <p className="text-[16px] font-medium leading-normal text-[#343434]"> {convertTimestampToDayMonthYear(auctionData.start_date, auctionData.time_zone, auctionData.start_time_zone)}</p>
                    </div>
                    <div className="md:w-[33%]  w-full pl-[35px] md:pl-0 mb-10">
                        <p className="text-[10px] font-medium leading-normal text-[#343434]">End Date / Time</p>
                        <p className="text-[16px] font-medium leading-normal text-[#343434]" data-testid='endDateTime'>  
                            {convertTimestampToDayMonthYear((auctionData.first_lot_end_date && auctionData.status!=="Completed" ) ? auctionData.first_lot_end_date : auctionData.end_date, auctionData.time_zone, auctionData.end_time_zone)}</p>
                    </div>
                    {auctionData.status!=="Draft" &&
                    <div className="w-full px-[35px] mb-10" >
                        <p className="text-[10px] font-medium leading-normal text-[#343434]">Auction Url</p>
                        <div className='flex items-center' >
                            <p className={`text-[16px] font-medium leading-normal text-[#343434] cursor-default break-all underline`} title={shareURL!==""  && shareURL} id='auction_url'>{shareURL}</p>
                            <div className={`flex ${copied?'text-[#41ad86]':'text-[#343434]'} text-[10px] 
                                        font-medium leading-normal w-[100px] items-center pl-2.5 h-full cursor-pointer`} onClick={()=>handleCopyLink()}>
                                <img src='/images/copy-url.svg' alt='icon' loading='lazy' className='pr-2.5' />
                                {copied ? 'Link Copied!' : 'Copy link'}
                            </div> 
                        </div>
                    </div>}
                </div>
            </div>
            {(auctionData?.event_display?.enable_leaderboard || auctionData?.event_display?.enable_carousel) && 
            <div className="mt-[25px] rounded-[8px] border-[#DEDEDE] border">
                <p className="py-5 border-b border-[#CECECE] pl-[35px] text-[16px] font-medium leading-normal
                    text-[#343434]">Event displays
                </p>
                <div className="flex flex-wrap mt-8 mb-[20px] w-full px-[35px] gap-3">
                    <div className='lg:w-[30%] md:w-[50%]'>
                        <button 
                            onClick={() => window.open(`/auctions/${auctionData._id}/${auctionData.auction_id}/leaderboard`, "_blank")}
                            disabled={(auctionData.status!=="Accepting bids" && auctionData.status!=="Published") || !auctionData?.event_display?.enable_leaderboard}
                            className="px-[31px] py-[7px] bg-[#282828] text-[#FFFFFF] 
                                leading-normal font-medium text-[14px] rounded-[6px] flex justify-center 
                                disabled:bg-[#D4D4D8] hover:bg-[#3F3F45]" data-testid='viewLeaderboard'>View leaderboard
                        </button>
                    </div>
                    <div className='lg:w-[30%] md:w-[50%]' >
                        <button 
                            onClick={() => window.open(`/auctions/${auctionData._id}/${auctionData.auction_id}/carousel-view`, "_blank")}
                            disabled={(auctionData.status!=="Accepting bids" && auctionData.status!=="Published") || !auctionData?.event_display?.enable_carousel}
                            className="px-[31px] py-[7px] bg-[#282828] text-[#FFFFFF] 
                                leading-normal font-medium text-[14px] rounded-[6px] flex justify-center 
                                disabled:bg-[#D4D4D8] hover:bg-[#3F3F45]" data-testid='viewCarousel'>View carousel
                        </button>
                    </div>
                </div>
            </div>}

            {/* <!-- rules content --> */}
            <div className="mt-[25px]  rounded-[8px] border-[#DEDEDE] border">
                <p className="py-5 border-b border-[#CECECE] pl-[35px] text-[16px] font-medium leading-normal 
                text-[#343434]">Rules</p>
                <div className="flex flex-wrap mt-8 mb-[10px] w-full px-[35px]">
                    <div className="md:w-[30%] xxs:w-[50%] w-full mb-[36px]">
                        <p className="text-[10px] font-medium leading-normal text-[#343434]">Type</p>
                        <p className="text-[16px]  font-medium leading-normal text-[#343434]">Timed Auction</p>
                    </div>
                    <div className="md:w-[33%] xxs:w-[50%] w-full mb-[36px]">
                        <p className="text-[10px] font-medium leading-normal text-[#343434]">Extension type</p>
                        <p className="text-[16px] font-medium leading-normal text-[#343434]">{auctionData.extension_type}</p>
                    </div>
                    <div className="md:w-[33%] xxs:w-[50%] w-full mb-[36px]">
                        <p className="text-[10px] font-medium leading-normal text-[#343434]">Extension time (mins)</p>
                        <p className="text-[16px]  font-medium leading-normal text-[#343434]">{auctionData.extension_time===''?'-':auctionData.extension_time}</p>
                    </div>
                    <div className="md:w-[30%] xxs:w-[50%] w-full mb-[36px]">
                        <p className="text-[10px] font-medium leading-normal text-[#343434]">Time between lots</p>
                        <p className="text-[16px] font-medium leading-normal text-[#343434]">{auctionData.extension_time_between_lots===''?'-':auctionData.extension_time_between_lots}</p>
                    </div>
                    <div className="md:w-[33%] xxs:w-[50%] w-full mb-[36px]">
                        <p className="text-[10px] font-medium leading-normal text-[#343434]">Registration type</p>
                        <p className="text-[16px]  font-medium leading-normal text-[#343434]">{auctionData.registration_type}</p>
                    </div>
                    <div className="md:w-[33%] xxs:w-[50%] w-full mb-[36px]">
                        <p className="text-[10px] font-medium leading-normal text-[#343434]">Buyer fees</p>
                        <p className="text-[16px] font-medium leading-normal text-[#343434]">{auctionData.add_buyer_fees.includes('No additional fees') ? auctionData.add_buyer_fees :
                            ( auctionData.add_buyer_fees=="Add percentage" ? (auctionData.percentage!==""  ? auctionData.percentage+'%' : '-' ) : (auctionData.fees=="" ? '-' : currencySymbolMapping[auctionData.currency]+auctionData.fees)  ) 
                        }</p>
                    </div>
                </div>
            </div>
            {/* <!-- privacy content --> */}
            <div className="mt-[25px]  rounded-[8px] border-[#DEDEDE] border">
                <p className="py-5 border-b border-[#CECECE] pl-[35px] text-[16px] font-medium leading-normal
                    text-[#343434]">Privacy</p>
                <div className="flex flex-wrap mt-8 mb-[10px]  w-full px-[35px]">
                    <div className="md:w-[30%] xxs:w-[50%] w-full mb-[36px]">
                        <p className="text-[10px] font-medium leading-normal text-[#343434]">Type</p>
                        <p className="text-[16px]  font-medium leading-normal text-[#343434]">{auctionData.make_your_auction_private===false ?'Public':'Private'}</p>
                    </div>
                    <div className="md:w-[33%] xxs:w-[50%] w-full mb-[36px]">
                        <p className="text-[10px] font-medium leading-normal text-[#343434]">Passcode</p>
                        <p className="text-[16px] font-medium leading-normal text-[#343434]">{auctionData.passcode===''?'-':auctionData.passcode}</p>
                    </div>
                    
                </div>
            </div>
        </div>
    )
}
